import React from 'react';
import Header from '../Header/Header';
import CaseStudyCard, { caseStudiesData } from './CaseStudyCard';

export default function CaseStudies() {
  return (
    <>
      <Header isActive={'Case Study'} />
      <div id="content" className="site-content">
        <div className="page-header dtable text-center" style={{ backgroundImage: 'url(resources/images/banner-.jpg)' }}>
          <div className="dcell">
            <div className="container">
              <h1 className="page-title">Case Studies</h1>
              <ul id="breadcrumbs" className="breadcrumbs">
                <li><a href="/">Home</a></li>
                <li className="active">Case Studies</li>
              </ul>
            </div>
          </div>
        </div>

        <section className="expertise-section" aria-labelledby="case-studies-title">
          <div className="container">
            <div className="expertise-heading">
              <h6><span>Our Work</span></h6>
              <h2 id="case-studies-title" className="main-heading">Real projects, real results</h2>
              <p>A look at how we've helped teams ship chatbots, data platforms, agentic AI, DevOps overhauls, MVPs, prototypes, and microservices at scale.</p>
            </div>
            <div className="expertise-grid">
              {caseStudiesData.map((caseStudy) => (
                <CaseStudyCard key={caseStudy.slug} caseStudy={caseStudy} />
              ))}
            </div>
            <div className="expertise-cta">
              <h3>Have a project like this in mind?</h3>
              <p>Let's talk about what we can build together.</p>
              <a className="octf-btn octf-btn-primary octf-btn-icon" href="/contact">
                <span>Talk to Our Experts <i className="flaticon-right-arrow-1"></i></span>
              </a>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
